import { render, staticRenderFns } from "./TextInputOptionsForm.vue?vue&type=template&id=524403a8&lang=pug"
import script from "./TextInputOptionsForm.vue?vue&type=script&lang=js"
export * from "./TextInputOptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports